import axios from "axios";
import router from "../router/index";

import { useGlobalStore } from "../store/modules/global";
// import 'core-js/proposals/promise-all-settled'
// call api 超時時間  同時CALL大量容易出錯
// 目前設定為60秒
axios.defaults.timeout = 60000;
// domain  // 域名
axios.defaults.baseURL = import.meta.env.VITE_DOMAIN;
//
// axios.defaults.withCredentials = true; // 允許跨域請求攜帶 cookies
// axios.defaults.headers.common['Content-Type'] = '~'
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded; charset=UTF-8 ";

// ==================================
// 訪問權限驗證相關配置
// ==================================
let accessVerificationCache = {
  lastVerified: null,
  isValid: false,
  trialInfo: null,
  cacheExpiry: 5 * 60 * 1000, // 5分鐘快取
};

// 驗證功能開關 - 可以暫時關閉來測試
const ACCESS_VERIFICATION_ENABLED = false; // 暫時禁用，因為API有錯誤

// 需要跳過驗證的API列表
const SKIP_VERIFICATION_URLS = [
  "/verify-access", // 避免無限循環
  "/api/trial/verify-access", // 正確的API路徑
  "/trail/verify-access", // 如果有前綴的版本
  "/login",
  "/register",
  "/forgotpw",
  "/reset-password-with-code",
  "/resend-verification",
  "/register/parent",
  "/parent_login/verify",
  "/validate_invitation_code",
  "/register_and_join_class",
  "login/logo", // 靜態資源
  "/blob/resdl/", // 檔案下載
];

// 檢查是否需要跳過驗證
function shouldSkipVerification(url) {
  return SKIP_VERIFICATION_URLS.some((skipUrl) => url.includes(skipUrl));
}

// 檢查快取是否有效
function isCacheValid() {
  if (!accessVerificationCache.lastVerified) return false;
  const now = Date.now();
  return (
    now - accessVerificationCache.lastVerified <
    accessVerificationCache.cacheExpiry
  );
}

// 執行訪問權限驗證
async function verifyAccess(token) {
  try {
    console.log("正在驗證訪問權限...");

    const response = await axios.get("/api/trial/verify-access", {
      baseURL: import.meta.env.VITE_TCH_DOMAIN,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      // 使用較短的超時時間避免阻塞其他請求太久
      timeout: 10000,
    });

    if (response.data.status === "success") {
      // 更新快取
      accessVerificationCache = {
        lastVerified: Date.now(),
        isValid: true,
        trialInfo: response.data.record,
        cacheExpiry: 5 * 60 * 1000,
      };

      console.log("訪問權限驗證成功:", response.data.record);
      return { success: true, data: response.data.record };
    } else {
      console.log("訪問權限驗證失敗:", response.data);
      accessVerificationCache.isValid = false;
      return { success: false, error: response.data.record };
    }
  } catch (error) {
    console.error("訪問權限驗證發生錯誤:", error);
    accessVerificationCache.isValid = false;
    return { success: false, error: error.message };
  }
}

// 處理驗證失敗的情況
function handleVerificationFailure(error, global) {
  console.log("處理驗證失敗:", error);

  // 清除快取
  accessVerificationCache.isValid = false;
  accessVerificationCache.lastVerified = null;

  // 顯示錯誤訊息
  global.$patch((state) => {
    state.alert.show = true;

    if (error.error_type === "token_invalid") {
      state.alert.message = "登入已過期，請重新登入";
      // 導向登入頁面
      setTimeout(() => {
        state.alert.show = false;
        router.push({ path: "/" });
      }, 2000);
    } else if (error.message && error.message.includes("試用期已過期")) {
      state.alert.message = "試用期已過期，請聯繫管理員升級帳戶";
    } else if (error.message) {
      state.alert.message = error.message;
    } else {
      state.alert.message = "訪問權限驗證失敗";
    }

    state.alert.status = "danger";
    setTimeout(() => {
      state.alert.show = false;
    }, 4000);
  });
}

// http request 欄截
axios.interceptors.request.use(
  async (config) => {
    // global loading
    const global = useGlobalStore();
    if (!global.hideLoading) {
      // 有些特例不要loading
      if (
        config.url.includes("/lazbook/getbookmark/") ||
        config.url.includes("/lazbook/setlog/") ||
        config.url.includes("/idx/entry") ||
        config.url.includes("/sign/idx/")
      ) {
      } else {
        // console.log("set loading");
        global.$patch((state) => {
          state.APIisLoading = true;
        });
      }
    }

    let token = localStorage.getItem("token");

    // ==================================
    // 訪問權限驗證邏輯
    // ==================================
    if (
      token &&
      !shouldSkipVerification(config.url) &&
      ACCESS_VERIFICATION_ENABLED
    ) {
      // 檢查快取是否有效
      if (!isCacheValid() || !accessVerificationCache.isValid) {
        console.log("需要重新驗證訪問權限");

        const verificationResult = await verifyAccess(token);

        if (!verificationResult.success) {
          // 驗證失敗，阻止請求繼續執行
          if (!global.hideLoading) {
            global.$patch((state) => {
              state.APIisLoading = false;
            });
          }

          handleVerificationFailure(verificationResult.error, global);

          // 拋出錯誤以阻止原始請求
          throw new Error(
            "Access verification failed: " +
              JSON.stringify(verificationResult.error)
          );
        }

        // 驗證成功，可以在這裡處理試用學生的特殊邏輯
        const { trial_info } = verificationResult.data;
        if (trial_info && trial_info.days_remaining !== undefined) {
          console.log(`試用學生剩餘天數: ${trial_info.days_remaining}`);

          // 如果剩餘天數少於3天，可以顯示提醒
          if (trial_info.days_remaining <= 3 && trial_info.days_remaining > 0) {
            global.$patch((state) => {
              state.alert.show = true;
              state.alert.message = `試用期剩餘 ${trial_info.days_remaining} 天，請及時升級帳戶`;
              state.alert.status = "warning";
              setTimeout(() => {
                state.alert.show = false;
              }, 3000);
            });
          }
        }
      } else {
        console.log("使用快取的驗證結果");
      }
    }

    // parent page
    if (
      config.url.includes("/parent/setaward/") ||
      config.url.includes("/parent/setimgpw/") ||
      config.url.includes("/parent/getchildren/") ||
      config.url.includes("/parent/dashboard/") ||
      config.url.includes("/utility/getvoice")
    ) {
      console.log(config.url, "use parent token");

      token = localStorage.getItem("parent_token");
      // console.log("token = ", token);
    }

    // book reading page
    if (
      config.url.includes("/reslist/detail/") ||
      config.url.includes("resdl/")
    ) {
      config.baseURL = import.meta.env.VITE_CMS_DOMAIN;
    }
    if (
      config.url.includes("/lazbook") ||
      config.url.includes("/content/recordspeaking/")
    ) {
      config.baseURL = import.meta.env.VITE_CLiENT_DOMAIN;
    }
    let viteDomain = import.meta.env.VITE_MSU_DOMAIN;
    if (config.url.includes("book/glossary") && viteDomain === "app") {
      config.baseURL = "https://lms-dev.mangosteems.com/";
    } else if (config.url.includes("book/glossary")) {
      config.baseURL = "https://lms.mangosteems.com/";
    }
    // 智能引導使用 WS_DOMAIN - 必須在 TCH_DOMAIN 條件之前
    if (config.url.includes("/aichat/ai/smart-guidance")) {
      console.log("🔧 攔截器檢測到 /aichat/ai/smart-guidance 路徑");

      // 根據環境設置正確的域名
      let smartGuidanceDomain;
      if (import.meta.env.MODE !== "development") {
        // 線上環境使用 app.mangosteems.com
        smartGuidanceDomain = "https://app.mangosteems.com";
      } else {
        // 開發環境使用 VITE_WS_DOMAIN2
        smartGuidanceDomain = import.meta.env.VITE_WS_DOMAIN2;
      }

      console.log("🔧 設置 baseURL 為:", smartGuidanceDomain);
      config.baseURL = smartGuidanceDomain;
      console.log("🔧 設置後的 config.baseURL:", config.baseURL);
    }

    // 翻譯 API 使用 app.mangosteems.com
    if (config.url.includes("/aichat/translate")) {
      console.log("🔧 攔截器檢測到 /aichat/translate 路徑");

      // 根據環境設置正確的域名
      let translateDomain;
      if (import.meta.env.MODE !== "development") {
        // 線上環境使用 app.mangosteems.com
        translateDomain = "https://app.mangosteems.com";
      } else {
        // 開發環境使用 VITE_WS_DOMAIN2
        translateDomain = import.meta.env.VITE_WS_DOMAIN2;
      }

      console.log("🔧 設置翻譯 API baseURL 為:", translateDomain);
      config.baseURL = translateDomain;
      console.log("🔧 設置後的 config.baseURL:", config.baseURL);
    }
    if (
      config.url.includes("ai_speech") ||
      config.url.includes("supplementary") ||
      config.url.includes("/register/parent") ||
      config.url.includes("/parent_login/verify") ||
      config.url.includes("/vocabulary-practice/student") ||
      config.url.includes("/resend-verification") ||
      config.url.includes("/forgotpw") ||
      config.url.includes("/reset-password-with-code") ||
      config.url.includes("/analyze-image") ||
      config.url.includes("/check-answer") ||
      config.url.includes("/add_learning_progress") ||
      config.url.includes("/get_student_progress") ||
      config.url.includes("/prize/") ||
      config.url.includes("/validate_invitation_code") ||
      config.url.includes("/register_and_join_class") ||
      config.url.includes("/student/reading-history") ||
      config.url.includes("/student/reading-summary") ||
      config.url.includes("/book/summaries") ||
      config.url.includes("/book/summary") ||
      config.url.includes("/student/reflection") ||
      config.url.includes("/student/reflections") ||
      config.url.includes("/ai/writing-prompts") ||
      config.url.includes("/ai/improve-text") ||
      config.url.includes("/ai/translate") ||
      config.url.includes("/get_student_assignment") ||
      config.url.includes("/api/subscription") ||
      config.url.includes("/daily-speech") ||
      config.url.includes("/add_student_subscription") ||
      config.url.includes("/student_subscription_status")
    ) {
      config.baseURL = import.meta.env.VITE_TCH_DOMAIN;
    }
    if (config.url.includes("core")) {
      config.baseURL = import.meta.env.VITE_AIBONUS_DOMAIN;
    }
    if (config.url.includes("aichat")) {
      config.baseURL = import.meta.env.VITE_AICHAT_DOMAIN;
    }
    //
    //
    // token && (config.headers.Authorization = 'Bearer' + token)
    config.headers = {
      ...config.headers, // 保留原有的 headers
      Authorization: "Bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    };

    if (
      config.url.includes("login/logo") ||
      config.url.includes("/blob/resdl/")
    ) {
      config.headers["responseType"] = "blob";
      console.log("responseType: blob");
    }
    if (config.url.includes("/blob/resdl/")) {
      config.url = config.url.replace("/blob/resdl/", "/resdl/");
    }
    if (config.url.includes("/utility/generate")) {
      config.headers["responseType"] = "blob";
    }
    if (
      config.url.includes("/aispk/get_quiz_sound/") ||
      config.url.includes("/aispk/get_ai_sound/")
    ) {
      config.responseType = "arraybuffer";
    }
    // console.log("token = ", token);
    console.log("url = ", config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 異常處理

axios.interceptors.response.use(
  (response) => {
    // console.log(response);
    const global = useGlobalStore();

    // stop loading
    if (!global.hideLoading) {
      global.$patch((state) => {
        state.APIisLoading = false;
      });
    }

    // show fail message
    if (response.data.status === "failed") {
      global.$patch((state) => {
        state.alert.show = true;
        if (response.data.message) {
          state.alert.message = response.data.message;
        } else {
          state.alert.message = response.data.record;
        }

        state.alert.status = "danger";
        setTimeout(() => {
          state.alert.show = false;
          if (
            response.data.record === "Token issue Not enough segments" ||
            response.data.record === "Token issue Invalid header padding"
          ) {
            router.push({
              path: "/",
            });
          }
        }, 4000);
      });
    }
    return response;
  },
  (err) => {
    // store.dispatch("common/setLoading", false);
    if (err && err.response) {
      // stop loading
      const global = useGlobalStore();
      if (!global.hideLoading) {
        global.$patch((state) => {
          state.APIisLoading = false;
        });
      }
      console.log("err && err.response = ", err && err.response);
      switch (err.response.status) {
        case 401:
          console.log("401 need refresh token");
          if (router.currentRoute !== "IndexPage") {
            setTimeout(() => {
              router.push({
                path: "/",
              });
            }, 1000);
          }
          break;
        case 404:
          console.log("找不到該頁面");
          // router.push({
          //   path: "/404",
          // });
          break;
        case 500:
          console.log("伺服器出錯");
          break;
        case 503:
          console.log("服務失效");
          break;
        default:
          console.log(`連接錯誤${err.response.status}`);
      }
    } else {
      console.log(err);
      console.log("連接到服務器失敗");
    }
    return Promise.resolve(err.response);
  }
);

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
        // console.log(response.config.responseType);
        // console.log(url, response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function post(url, data = {}, config = {}) {
  console.log("post url = ", url);
  console.log("post data = ", data);
  let mergedConfig = {
    headers: {
      "Content-Type": "application/json",
      ...config.headers,
    },
    ...config,
  };

  // 特殊處理圖形密碼：確保 emoji 不被轉換為 Unicode 轉義序列
  if (data && data.userData && data.userData.patternPw) {
    console.log("處理圖形密碼，保持 emoji 原始格式", data.userData.patternPw);
  }

  // 特殊 API 的處理
  if (url.includes("/analyze-image") || url.includes("/check-answer")) {
    mergedConfig.headers["Content-Type"] = "application/json";

    // 如果是 FormData，轉換為 JSON
    if (data instanceof FormData) {
      const jsonData = {};
      for (let [key, value] of data.entries()) {
        jsonData[key] = value;
      }
      data = jsonData;
    }
  }

  // 只有 check-answer 端點需要 withCredentials
  if (url.includes("/check-answer")) {
    mergedConfig.withCredentials = true;
  }

  // 添加自定義序列化設置，確保 emoji 保持原樣
  // 這可以防止 axios 默認的 JSON.stringify 行為將 emoji 轉為 Unicode 轉義序列
  if (url.includes("/register_and_join_class")) {
    mergedConfig.transformRequest = [
      function (data) {
        // 使用自定義的 JSON.stringify，保持 emoji 原樣
        return JSON.stringify(data);
      },
    ];
  }

  return new Promise((resolve, reject) => {
    axios
      .post(url, data, mergedConfig)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("Post error:", err);
        reject(err);
      });
  });
}
export function getFile(url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        responseType: "blob",
        ...config,
        headers: {
          Accept: "*/*",
          ...config.headers,
        },
      })
      .then((response) => {
        console.log("Response headers:", response.headers);
        console.log("Response type:", response.data.type);
        console.log("Response size:", response.data.size);

        // 檢查是否為錯誤響應
        if (response.data.type === "application/json") {
          response.data.text().then((text) => {
            console.error("Received JSON:", text);
            reject(new Error(JSON.parse(text).message || "Download failed"));
          });
        } else {
          resolve(response);
        }
      })
      .catch((err) => {
        console.error("Request error:", err);
        console.error("Error response:", err.response);
        reject(err);
      });
  });
}

export function voicepost(url, data = {}, config = {}) {
  console.log("Posting data to URL:", url);
  console.log("Post data type:", typeof data);
  console.log("Is FormData:", data instanceof FormData);

  if (data instanceof FormData) {
    for (let [key, value] of data.entries()) {
      console.log(key, value);
    }

    // 確保 FormData 中的文件名符合服務器要求
    const audioFile = data.get("audio");
    if (audioFile instanceof File) {
      data.delete("audio");
      data.append("audio", audioFile, "audio.webm");
    }
  }

  // 合併配置，確保設置正確的 Content-Type
  const mergedConfig = {
    ...config,
    headers: {
      "Content-Type": "multipart/form-data",
      ...config.headers,
    },
  };

  return new Promise((resolve, reject) => {
    axios
      .post(url, data, mergedConfig)
      .then((response) => {
        console.log(response);
        console.log("Post response:", response.data);
        resolve(response.data);
      })
      .catch((err) => {
        console.error("Post error:", err);
        console.error("Error response:", err.response);
        reject(err);
      });
  });
}

export function remove(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//cors issue use fetch get
//url要注意
export function fetchget(url, params = {}) {
  const controller = new AbortController();
  const signal = controller.signal;
  let token = localStorage.getItem("token");
  // console.log(token);
  let respType = "";
  console.log(import.meta.env.VITE_DOMAIN);
  return fetch(import.meta.env.VITE_DOMAIN + url, {
    method: "GET",
    signal: signal,
    headers: {
      Authorization: "Bearer " + token,
    },
  }).then(function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      console.log(response);

      var contentType = response.headers.get("content-type");
      // console.log(contentType);

      if (contentType && contentType.includes("application/json")) {
        respType = "json";
        return response.json();
      } else if (contentType && contentType.includes("application/pdf")) {
        var params = {
          token: token,
        };

        //Add authentication headers in URL
        var url = [response.url, $.param(params)].join("?");

        controller.abort(); //如果不丟一個中止，會一直在背景下載
        window.open(url, "_blank");
      } else {
        respType = contentType;
        return response.blob(); // image 要用 blob
      }
    } else {
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  });
}
export function fetchget2(url, params = {}) {
  const controller = new AbortController();
  const signal = controller.signal;
  let token = localStorage.getItem("token");
  // console.log(token);
  let respType = "";
  console.log(import.meta.env.VITE_TCH_DOMAIN);
  return fetch(import.meta.env.VITE_TCH_DOMAIN + url, {
    method: "GET",
    signal: signal,
    headers: {
      Authorization: "Bearer " + token,
    },
  }).then(function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      console.log(response);

      var contentType = response.headers.get("content-type");
      // console.log(contentType);

      if (contentType && contentType.includes("application/json")) {
        respType = "json";
        return response.json();
      } else if (contentType && contentType.includes("application/pdf")) {
        var params = {
          token: token,
        };

        //Add authentication headers in URL
        var url = [response.url, $.param(params)].join("?");

        controller.abort(); //如果不丟一個中止，會一直在背景下載
        window.open(url, "_blank");
      } else {
        respType = contentType;
        return response.blob(); // image 要用 blob
      }
    } else {
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  });
}

// axios all
export function getAll(url, data = {}, array) {
  return new Promise.all(
    array.map((item) => {
      axios
        .get(url, data)
        .then((result) => {
          return result;
        })
        .catch((err) => {
          return err;
        });
    })
  );
}
export function getPromiseAll(urlArray) {
  return Promise.all(
    urlArray.map((url) => {
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    })
  );
}

export function postPromiseAll(urlArray) {
  return Promise.all(
    urlArray.map((item) => {
      console.log(item);
      return new Promise((resolve, reject) => {
        console.log(item.audio);
        axios
          .post(item.url, item.audio)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    })
  );
}

// ==================================
// 訪問權限驗證工具函數
// ==================================

/**
 * 手動清除訪問權限快取
 * 當用戶登出或需要強制重新驗證時使用
 */
export function clearAccessCache() {
  accessVerificationCache = {
    lastVerified: null,
    isValid: false,
    trialInfo: null,
    cacheExpiry: 5 * 60 * 1000,
  };
  console.log("訪問權限快取已清除");
}

/**
 * 手動驗證訪問權限
 * 返回驗證結果和試用資訊
 */
export async function manualVerifyAccess() {
  const token = localStorage.getItem("token");
  if (!token) {
    return { success: false, error: "No token found" };
  }

  return await verifyAccess(token);
}

/**
 * 獲取當前快取的試用資訊
 */
export function getTrialInfo() {
  if (isCacheValid() && accessVerificationCache.isValid) {
    return accessVerificationCache.trialInfo;
  }
  return null;
}

/**
 * 檢查當前用戶是否為試用學生
 */
export function isTrialStudent() {
  const trialInfo = getTrialInfo();
  return trialInfo?.is_trial_student || false;
}

/**
 * 獲取試用期剩餘天數
 */
export function getTrialDaysRemaining() {
  const trialInfo = getTrialInfo();
  return trialInfo?.trial_info?.days_remaining || null;
}

/**
 * 設定快取過期時間（毫秒）
 * @param {number} expiry - 快取過期時間（毫秒）
 */
export function setAccessCacheExpiry(expiry) {
  accessVerificationCache.cacheExpiry = expiry;
  console.log(`訪問權限快取過期時間設定為: ${expiry}ms`);
}

/**
 * 添加需要跳過驗證的URL
 * @param {string} url - 需要跳過驗證的URL模式
 */
export function addSkipVerificationUrl(url) {
  if (!SKIP_VERIFICATION_URLS.includes(url)) {
    SKIP_VERIFICATION_URLS.push(url);
    console.log(`已添加跳過驗證的URL: ${url}`);
  }
}

/**
 * 檢查訪問權限快取狀態
 */
export function getAccessCacheStatus() {
  return {
    isValid: accessVerificationCache.isValid,
    lastVerified: accessVerificationCache.lastVerified,
    cacheExpiry: accessVerificationCache.cacheExpiry,
    isCacheValid: isCacheValid(),
    trialInfo: accessVerificationCache.trialInfo,
    verificationEnabled: ACCESS_VERIFICATION_ENABLED,
  };
}

/**
 * 啟用訪問權限驗證
 * 當後端API準備好時使用
 */
export function enableAccessVerification() {
  // 注意：這需要修改常數，實際使用時建議通過環境變數或配置文件控制
  console.log("⚠️  要啟用驗證，請將 ACCESS_VERIFICATION_ENABLED 設為 true");
  console.log(
    "🔧 建議在 request.js 中修改：const ACCESS_VERIFICATION_ENABLED = true;"
  );
}

/**
 * 測試 verify-access API 是否可用
 */
export async function testVerifyAccessAPI() {
  const token = localStorage.getItem("token");
  if (!token) {
    return { success: false, error: "No token found" };
  }

  console.log("🧪 測試 verify-access API...");
  console.log("🌐 使用域名:", import.meta.env.VITE_TCH_DOMAIN);

  const result = await verifyAccess(token);

  if (result.success) {
    console.log("✅ API 測試成功！可以啟用驗證功能");
  } else {
    console.log("❌ API 測試失敗:", result.error);
  }

  return result;
}
